import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="max-w-md mx-auto py-24 text-center text-ink/50">Checking session…</div>;
  if (!admin) return <Navigate to="/admin" replace />;
  return children;
}
